import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../abilities/Can';

export function useShowHelpFooter() {
	const ability = useAbility(AbilityContext);

	return ability.can('show', 'spotlight_help_modal');
}
